<script setup lang="ts">
    import { ref, computed } from 'vue';
    import { useSqlEditorStore } from '@/stores/sqlEditorStore.ts';
    import { BTooltip } from 'buefy';

    const store = useSqlEditorStore();
    const executing = ref(false);

    const runButtonClass = computed(() => {
        return {
            button: true,
            'is-primary': true,
            'is-loading': executing.value
        };
    });

    async function runQuery() {
        executing.value = true;
        await store.runQuery();
        executing.value = false;
    }
</script>

<template>
    <button
        :class="runButtonClass"
        title="Run query"
        @click="runQuery">
        <b-tooltip label="Shortcut: Ctrl+Enter">
            <b-icon
                icon="play"
                size="is-small" />
            <span>Run</span>
        </b-tooltip>
    </button>
</template>
